var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5237 0C16.8319 0 18.0902 0.53 19.0159 1.481C19.9426 2.43 20.4606 3.71 20.4606 5.05V12.95C20.4606 15.74 18.2463 18 15.5237 18H5.88706C3.16452 18 0.951172 15.74 0.951172 12.95V5.05C0.951172 2.26 3.15476 0 5.88706 0H15.5237ZM17.0757 6.54L17.1538 6.46C17.3869 6.17 17.3869 5.75 17.143 5.46C17.0074 5.311 16.8211 5.22 16.627 5.2C16.4222 5.189 16.2271 5.26 16.0798 5.4L11.6814 9C11.1156 9.481 10.305 9.481 9.73042 9L5.3408 5.4C5.03742 5.17 4.61797 5.2 4.36532 5.47C4.10195 5.74 4.07268 6.17 4.29607 6.47L4.42385 6.6L8.86225 10.15C9.40851 10.59 10.0709 10.83 10.7644 10.83C11.456 10.83 12.1301 10.59 12.6754 10.15L17.0757 6.54Z",
    fill: "#B0B7C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.559632fa.svg";
export { ForwardRef as ReactComponent };